import Button from '@doordash/component-button'
import { Text, StackChildren, Colors, Inline } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../events'
import AddBankAccountModal from '../../molecules/add-bank-account-modal'
import { paymentSetup } from './strings'
import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import * as Exp from '../../../experimentConstants'
import { Interpolate } from '@doordash/lib-i18n'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'
import { DASHER_DIRECT_URL } from '../../../constants'
import { get } from 'lodash'

type PaymentSetupStepProps = {
  isActive: boolean
  isComplete: boolean
  uniqueLink: string
  stripe: any
  trackConfirmationPageTapDownloadApp?: () => Promise<any>
  trackConfirmationPageClick?: (name: string) => Promise<any>
  skipStep?: () => Promise<any>
  experiments: object
}

type PaymentSetupStepState = {
  isShowingModal: boolean
}

export class PaymentSetupStep extends React.Component<
  PaymentSetupStepProps,
  PaymentSetupStepState
> {
  public state = {
    isShowingModal: false,
  }

  public toggleModal(e) {
    e.stopPropagation()
    const isShowingModal = !this.state.isShowingModal

    this.setState({
      isShowingModal,
    })
  }
  public render() {
    const { isActive, stripe, skipStep, experiments } = this.props
    const bankAccountSkipExperiment = get(
      experiments,
      Exp.DX_BANK_ACCOUNT_SKIP,
      false
    )

    const shoudHideFastpayMessage = get(
      experiments,
      Exp.HIDE_FASTPAY_MESSAGE,
      false
    )

    const i18nKey = shoudHideFastpayMessage
      ? i18nKeys.bankOnboarding__bankAccountSkipSubSection_noFastpay
      : i18nKeys.bankOnboarding__bankAccountSkipSubSection

    const paymentSetupSection = (
      <React.Fragment>
        <Text color={Colors.SystemGrey80}>
          {bankAccountSkipExperiment ? (
            <Interpolate
              i18n={i18n}
              i18nKey={i18nKey}
              components={[
                <Text
                  display={Text.DisplayModes.Inline}
                  color={Colors.SystemGrey80}
                  tag="a"
                  target="_blank"
                  href={DASHER_DIRECT_URL}
                />,
              ]}
            />
          ) : (
            paymentSetup.titleSubtext()
          )}
        </Text>
        <div>
          <Inline tag={'span'} size={Inline.Sizes.XxSmall}>
            <Button
              type={Button.Types.PrimaryPill}
              size={Button.Sizes.Small}
              tag="a"
              onClick={e => {
                this.props.trackConfirmationPageClick('add_bank_account_button')
                this.toggleModal(e)
              }}
              isInline
            >
              {paymentSetup.addBankAccount()}
            </Button>
          </Inline>

          {bankAccountSkipExperiment && (
            <Button
              type={Button.Types.TertiaryPill}
              size={Button.Sizes.Small}
              tag="a"
              onClick={skipStep}
              isInline
            >
              {paymentSetup.skipForNow()}
            </Button>
          )}
        </div>
        {this.state.isShowingModal && (
          <AddBankAccountModal
            uniqueLink={this.props.uniqueLink}
            onClose={this.toggleModal.bind(this)}
            stripe={stripe}
            isW2Dasher={isFeatureFlagEnabled(Exp.W_MODEL_EXPERIMENT)}
            skipStep={this.props.skipStep}
            locale={i18n.getCurrentLocale()}
          />
        )}
      </React.Fragment>
    )

    const futurePaymentSetup = (
      <Text styles={Text.Styles.SectionSubtext}>{paymentSetup.future()}</Text>
    )

    return (
      <StackChildren>
        {isActive ? paymentSetupSection : futurePaymentSetup}
      </StackChildren>
    )
  }
}
const mapStateToProps = state => ({
  experiments: state.experiments,
})

const mapDispatchToProps = {
  trackConfirmationPageTapDownloadApp:
    events.trackConfirmationPageTapDownloadApp,
  trackConfirmationPageClick: events.trackConfirmationPageClick,
}
export default connect(mapStateToProps, mapDispatchToProps)(PaymentSetupStep)
